<template>
  <div class="employment-wrapper">
    <!-- employment list -->
    <div class="employment-widget" v-if="is_items_list_open">
      <ul class="employment-items" v-if="profile_data.employments.length > 0">
        <li class="employment-starter">
          <div class="employment-item-header">
            <label
              >Employments ({{
                profile_data.employments.length | validate
              }})</label
            >
            <button class="btn-add" @click="addUpdateForm()">
              Add Employment +
            </button>
          </div>
        </li>
        <li
          class="employment-item"
          v-for="(item, i) in profile_data.employments"
          :key="i"
        >
          <panel-expand>
            <template v-slot:header="{ options }">
              <div
                class="employment-item-header"
                :class="{ no_expand: !options.expanded }"
                @click="options.expanded = true"
              >
                <div class="employment-item-brand">
                  <img src="@/assets/icons/projects_icon.svg" />
                </div>
                <div class="content">
                  <div class="title-row">
                    <label>{{ item.company.name | validate }}</label>
                    <span>{{ item.role | validate }}</span>
                    <span class="date">
                      <span v-if="item.from">{{
                        item.from | formatDate | validate
                      }}</span>
                      <span class="separator" v-if="item.from && item.to"
                        >-</span
                      >
                      <span v-if="item.to">{{
                        item.to | formatDate | validate
                      }}</span>
                    </span>
                  </div>
                  <div class="options">
                    <div class="btns">
                      <dropdown-menu>
                        <ul>
                          <li>
                            <a @click.prevent="editEmployment(item)" href
                              >Edit Employment</a
                            >
                          </li>
                          <li>
                            <app-dialog
                              title="Delete Employment"
                              ask="Are you sure you want to permanently delete this employment?"
                              yesText="Delete"
                              noText="Cancel"
                              yesBtnClass="btn-danger"
                              @onComfirm="deleteEmployment(item.id, i)"
                            >
                              <a href="#">Delete Employment</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>
                    </div>
                    <span v-if="item.verified" class="verified-status"
                      >Verified</span
                    >

                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                      v-if="!options.expanded"
                    >
                      <img src="@/assets/admin-icon/icon-down.svg" />
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:main="{ options }">
              <div class="employment-item-body">
                <div class="employment-info">
                  <h5>Company</h5>
                  <p>{{ item.company.name | validate }}</p>
                  <h5>Location</h5>
                  <p>
                    <span v-if="item.address">{{
                      item.address | validate
                    }}</span>
                  </p>
                  <h5 v-if="item.description">Description</h5>
                  <p v-html="item.description"></p>
                  <h5 v-if="item.members.length > 0">Members</h5>
                  <div class="collaboraters-widget">
                    <div
                      class="item"
                      v-for="(item, i) in item.members"
                      :key="i"
                    >
                      <img
                        v-if="item.profile_picture"
                        class="profile-img"
                        :src="
                          $fullUrl('images/profiles/' + item.profile_picture)
                        "
                        alt
                      />
                      <img
                        class="profile-img"
                        v-else
                        src="@/assets/icons/logo_avatar.svg"
                        alt
                      />
                      <span class="name"
                        >{{ item.first_name | validate }}
                        {{ item.last_name | validate }}</span
                      >
                    </div>
                  </div>
                  <h5>Skills</h5>
                  <div class="skills-widget">
                    <div class="skills_content__wrapper">
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Tools</label>
                        </div>
                        <div
                          class="skill_box_body"
                          v-if="item.skills.tools.length > 0"
                        >
                          <div
                            class="row__item"
                            v-for="(value, i) in item.skills.tools.slice(0, 5)"
                            :key="i"
                          >
                            <span>{{ value.name | validate }}</span>
                            <star-rating
                              inactive-color="#C1C1C1"
                              :read-only="true"
                              active-color="#1BA5A4"
                              :star-size="14"
                              :show-rating="false"
                              v-model="value.level"
                            ></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any tool yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Domains</label>
                        </div>
                        <div
                          class="skill_box_body"
                          v-if="item.skills.domains.length > 0"
                        >
                          <div
                            class="row__item"
                            v-for="(value, i) in item.skills.domains.slice(
                              0,
                              5
                            )"
                            :key="i"
                          >
                            <span>{{ value.name | validate }}</span>
                            <star-rating
                              inactive-color="#C1C1C1"
                              :read-only="true"
                              active-color="#1BA5A4"
                              :star-size="14"
                              :show-rating="false"
                              v-model="value.level"
                            ></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any domain yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Languages</label>
                        </div>
                        <div
                          class="skill_box_body"
                          v-if="item.skills.languages.length > 0"
                        >
                          <div
                            class="row__item"
                            v-for="(value, i) in item.skills.languages.slice(
                              0,
                              5
                            )"
                            :key="i"
                          >
                            <span>{{ value.lang.name | validate }}</span>
                            <star-rating
                              inactive-color="#C1C1C1"
                              :read-only="true"
                              active-color="#1BA5A4"
                              :star-size="14"
                              :show-rating="false"
                              v-model="value.level"
                            ></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any language yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="next_skills_content__wrapper">
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Competences</label>
                        </div>
                        <div
                          class="skill_box_body"
                          v-if="item.skills.competences.length > 0"
                        >
                          <div
                            class="row__item"
                            v-for="(value, i) in item.skills.competences.slice(
                              0,
                              5
                            )"
                            :key="i"
                          >
                            <span>{{ value.name | validate }}</span>
                            <star-rating
                              inactive-color="#C1C1C1"
                              :read-only="true"
                              active-color="#1BA5A4"
                              :star-size="14"
                              :show-rating="false"
                              v-model="value.level"
                            ></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any competence yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Roles</label>
                        </div>
                        <div
                          class="skill_box_body"
                          v-if="item.skills.roles.length > 0"
                        >
                          <div
                            class="row__item"
                            v-for="(value, i) in item.skills.roles.slice(0, 5)"
                            :key="i"
                          >
                            <span>{{ value.name | validate }}</span>
                            <star-rating
                              inactive-color="#C1C1C1"
                              :read-only="true"
                              active-color="#1BA5A4"
                              :star-size="14"
                              :show-rating="false"
                              v-model="value.level"
                            ></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any role yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="employment-item-body-option">
                  <button
                    class="toogle-panel-btn"
                    @click="options.expanded = !options.expanded"
                  >
                    <img src="@/assets/icons/up.svg" />
                  </button>
                </div>
              </div>
            </template>
          </panel-expand>
        </li>
      </ul>
      <div class="empty-widget" v-else>
        <div class="empty-widgetheader">
          <label>Employments</label>
        </div>
        <div class="empty-widget-body">
          <p>
            You have not yet added employments yet,
            <br />Click below to add one
          </p>
          <button class="add-btn" @click="addUpdateForm()">
            Add a Employment
          </button>
        </div>
      </div>
    </div>

    <!-- Add and update form -->
    <div class="add-update-form" v-if="add_update_form">
      <div class="form">
        <div class="imployment-form">
          <h2 v-if="!newEmployment.id">Create an Employment</h2>
          <h2 v-else>Update Employment</h2>
          <form @submit.prevent="submitEmployment()" data-vv-scope="add-emply">
            <div class="form-group">
              <div class="__box">
                <span>
                  Company Name
                  <b>*</b>
                </span>
                <input
                  type="text"
                  placeholder="Eg: Tesla"
                  name="new_employment__company"
                  :class="{
                    error_input: errors.first('new_employment__company'),
                  }"
                  v-validate="'required'"
                  v-model="newEmployment.company"
                  class="__textview"
                  ref="searchMember"
                />
                <span
                  class="error_alert"
                  v-if="errors.has('add-emply.new_employment__company')"
                  >Company name is required</span
                >
              </div>
              <div style="width: 10px"></div>
              <div class="__box">
                <span>
                  Role
                  <b>*</b>
                </span>
                <input
                  type="text"
                  name="new_employment__role"
                  :class="{ error_input: errors.first('new_employment__role') }"
                  v-validate="'required'"
                  v-model="newEmployment.role"
                  placeholder="What do you do"
                  class="__textview"
                />
                <span
                  class="error_alert"
                  v-if="errors.has('add-emply.new_employment__role')"
                  >Role is required</span
                >
              </div>
            </div>
            <div class="form-group">
              <div class="__box">
                <div style="display: flex; justify-content: space-between">
                  <span>
                    Time Frame
                    <b>*</b>
                  </span>
                  <div style="display: flex">
                    <label class="check-label" for="now6"
                      >Current Employment</label
                    >
                    <input
                      type="checkbox"
                      id="now6"
                      style="margin-top: 5px; margin-left: 5px"
                      v-model="datepickers.picker3"
                      @change="setCurrentTime('new-employment')"
                    />
                  </div>
                </div>
                <div
                  class="grouped"
                  :class="{ disabling: datepickers.picker3 }"
                >
                  <datepicker
                    placeholder="From"
                    name="new_employment__from"
                    v-validate="'required'"
                    :disabled="datepickers.picker3"
                    v-model="newEmployment.from"
                    input-class="__date-field"
                    wrapper-class="__date-field"
                  ></datepicker>
                  <div style="width: 5px"></div>
                  <datepicker
                    placeholder="To"
                    :disabled="datepickers.picker3 || newEmployment.from === ''"
                    :disabled-dates="{ to: newEmployment.from }"
                    v-model="newEmployment.to"
                    input-class="__date-field2"
                    wrapper-class="__date-field2"
                  ></datepicker>
                </div>
                <span
                  class="error_alert"
                  v-if="errors.has('add-emply.new_employment__from')"
                  >Date is required</span
                >
              </div>
              <div style="width: 10px"></div>
              <div class="__box"></div>
            </div>
            <div class="__box">
              <span>Description</span>
              <html-editor
                v-model="newEmployment.description"
                id="empoy-descr"
              />
            </div>

            <div class="form-group" style="flex-direction: column">
              <span style="margin-top: 24px; margin-bottom: 1px">
                Location
                <b>*</b>
              </span>
              <div style="display: flex">
                <div class="__box">
                  <map-helper v-model="newEmployment.address"></map-helper>
                  <span class="error_alert" v-if="errors.has('form-1.address')"
                    >Locationis required</span
                  >
                </div>
              </div>
            </div>
            <div class="__box">
              <span class="helper-widget">
                <label>Colleagues</label>
                <help-tool-tip
                  text="Colleagues will be added to the employment as soon as they have confirmed the invitation."
                />
              </span>
              <div class="input__dropdown">
                <div class="dropdown__wrapper">
                  <div class="invite-widget">
                    <input
                      type="text"
                      placeholder="Search for employment members…"
                      v-model="search_consultant_member"
                      class="__textview"
                      ref="searchMember"
                    />
                    <label>Or invite them via Email</label>
                    <button
                      class="btn-invite-via-email"
                      @click.prevent="
                        (e) => {
                          invitation.target = newEmployment.member;
                          showAddemploymentInviteModel = true;
                        }
                      "
                    >
                      Invite via Email
                    </button>
                  </div>
                  <span class="help-widget-absolute">
                    <help-tool-tip
                      position="top left"
                      text="This button provides the possibility to add employment members not registered on Consultified."
                    />
                  </span>

                  <div
                    v-show="
                      company_member_list &&
                      company_member_list.length > 0 &&
                      search_consultant_member
                    "
                    class="dropdown__body"
                  >
                    <div
                      class="dropdown__item"
                      v-for="(person, i) in company_member_list"
                      :key="i"
                      @click="addMate(person)"
                    >
                      <img
                        v-if="person.profile_picture"
                        :src="
                          $fullUrl('images/profiles/' + person.profile_picture)
                        "
                        alt="picture"
                      />
                      <img v-else src="@/assets/avatar.png" alt />
                      <div class="text">
                        <span>{{
                          (person.first_name + " " + person.last_name)
                            | validate
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="__people" v-show="newEmployment.people.length > 0">
                <div
                  class="person__item"
                  v-for="(member, i) in newEmployment.people"
                  :key="i + 'sdjks'"
                >
                  <div class="person_avatar">
                    <img
                      v-if="member.picture"
                      :src="$fullUrl('images/profiles/' + member.picture)"
                      alt
                    />
                    <img v-else src="@/assets/avatar.png" alt />
                    <span class="person_name">{{
                      member.names | validate
                    }}</span>
                  </div>
                  <div
                    class="__close"
                    @click="
                      () => {
                        newEmployment.people.splice(i, 1);
                      }
                    "
                  >
                    <img src="@/assets/icons/close.svg" />
                  </div>
                </div>
              </div>
            </div>

            <div class="__box">
              <span class="__m20">Skills</span>
              <skillsInput
                v-model="newEmployment.skills"
                :data="newEmployment.skills_data"
              />
            </div>

            <div class="__btns">
              <consultfied-button
                :loading="save_employment_loading"
                class="btn-save"
                >Save</consultfied-button
              >
              <button class="btn-cancel" @click="closeAddUpdateForm()">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Verify form -->
    <div class="verify-form" v-show="show_verify">
      <div class="employment-form">
        <div>
          <h2 class="__green">Employment Verification</h2>
        </div>
        <div class="__cardsss">
          <div class="__box">
            <div class="__row-1">
              <span class="__label">Company Domain</span>
            </div>
            <div class="input-group">
              <input
                type="text"
                v-model="request.domain"
                placeholder="E.g.  consultified.com"
                class
              />
            </div>
          </div>
          <div class="__box">
            <div class="__row-1">
              <span class="__label">Company Email</span>
            </div>
            <div class="input-group">
              <input
                type="text"
                v-model="request.email"
                placeholder="E.g.  johndoe@consultified.com"
                class
              />
            </div>
          </div>
          <div class="__btns">
            <consultfied-button
              :loading="verify_employment_loading"
              @click="verifyEmployment()"
              class="save"
              >Send a request</consultfied-button
            >
            <button class="cancel" @click="closeVerifyForm()">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Invite via email form -->
    <template>
      <v-layout
        justify-center
        style="z-index: 99999; border-radius: 5px; overflow: hidden"
      >
        <v-dialog
          v-model="showAddemploymentInviteModel"
          persistent
          max-width="500"
          style="border-radius: 5px"
        >
          <v-card color="#D9D9D9">
            <v-layout>
              <div class="card__body">
                <div class="__layout">
                  <div class="div">
                    <label>Email address</label>
                    <input
                      type="text"
                      placeholder="E.g. abcd@youremail.com"
                      v-model="invitation.email"
                    />
                  </div>
                  <div class="div">
                    <label>Message</label>
                    <div class="msg">
                      Dear Sir/Madam,
                      <br />
                      <br />I have invited you as a member of a employment.
                      Please get back to me to confirm your participation to the
                      employment through the link below.
                      <br />
                      <br />Kind regards,
                      <br />
                      <br />User name
                    </div>
                  </div>
                  <div class="btns-2">
                    <consultfied-button
                      :loading="envitation_employment_loading"
                      @click="sendEmploymentInvitation()"
                      class="save"
                      >Send</consultfied-button
                    >
                    <button
                      class="cancel"
                      @click="showAddemploymentInviteModel = false"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import panelExpand from "@/components/Partials/panelExpand";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import Datepicker from "vuejs-datepicker";
import skillsInput from "@/components/Partials/skillsInput.vue";
import HelpToolTip from "@/components/helper/HelpToolTip.vue";
import HtmlEditor from "@/components/helper/HtmlEditor.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Employment",
  components: {
    appDialog,
    panelExpand,
    consultfiedButton,
    Datepicker,
    skillsInput,
    HelpToolTip,
    HtmlEditor,
  },

  data: () => {
    return {
      company_member_list: [],
      search_consultant_member: "",
      add_update_form: false,
      is_items_list_open: true,
      show_verify: false,
      showAddemploymentInviteModel: false,
      save_employment_loading: false,
      datepickers: {
        picker1: false,
        picker2: false,
        picker3: false,
        picker4: false,
      },
      invitation: {
        target: "",
        email: "",
        note: "",
        type: "",
        id: 0,
      },
      newEmployment: {
        skills: {},
        skills_data: [],
        name: "",
        company: "",
        from: "",
        to: "",
        country: 0,
        city: 0,
        address: "",
        location: {
          country: 0,
          city: 0,
          address: "",
        },
        description: "",
        hourly_rate: "",
        member: "",
        langs: [],
        members: [],
        people: [],
        invites: [],
        langNames: [],
        show: false,
        roles: [],
        role: "",
      },
      profile_data: {
        user: {},
        employments: [],
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
      },
      request: {
        domain: "",
        email: "",
      },
      envitation_employment_loading: false,
      verify_employment_loading: false,
      id: null,
      company_id: null,
    };
  },
  mounted() {
    let vm = this;
    vm.id = vm.$route.params.id;
    vm.company_id = vm.$route.params.company_id;
    vm.getConsultantData(vm.id);
    vm.$store.dispatch("GET_COUNTRIES");
  },
  computed: {
    ...mapGetters(["getCountries", "getCities", "getSearchedPeople"]),
  },
  methods: {
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
        closable: true,
      };
      vm.newEmployment.people.push(obj);
      vm.search_consultant_member = "";
    },
    searchPeople(query) {
      let vm = this;
      vm.$store
        .dispatch("SEARCH_FOR_COMPANY_MEMBERS", {
          query: query,
        })
        .then((responce) => {
          vm.company_member_list = responce.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    verifyEmployment() {
      let vm = this;
      eventBus.$set(vm.request, "user_id", vm.id);
      vm.verify_employment_loading = true;
      vm.$store
        .dispatch("COMPANY_CONSULTANT_VERIFY_EMPLOYMENT", vm.request)
        .then((responce) => {
          vm.closeVerifyForm();
          vm.verify_employment_loading = false;
        })
        .catch((error) => {
          vm.verify_employment_loading = false;
          console.log({
            error,
          });
        });
    },
    sendEmploymentInvitation() {
      let vm = this;
      vm.showAddemploymentInviteModel = false;
    },
    deleteEmployment(id, i) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_CONSULTANT_DELETE_EMPLOYMENT", {
          id: id,
          user_id: vm.id,
        })
        .then((responce) => {
          if (i > -1) {
            vm.profile_data.employments.splice(i, 1);
          }
        })
        .catch((error) => {
          console.log({
            error,
          });
        });
    },
    moment,
    editEmployment(item) {
      let vm = this;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
      // fields
      vm.newEmployment.id = item.id;
      vm.newEmployment.skills_data = item.skills_data;
      vm.newEmployment.company = item.company.name;
      vm.newEmployment.from = vm.$dateObj(item.from);
      vm.newEmployment.to = vm.$dateObj(item.to);
      vm.newEmployment.description = item.description;
      vm.newEmployment.address = item.address;
      //vm.newEmployment.member = item.members;
      vm.newEmployment.role = item.role;
    },
    submitEmployment() {
      let vm = this;
      this.$validator.validateAll("add-emply").then((isError) => {
        if (isError === true) {
          vm.save_employment_loading = true;
          eventBus.$set(vm.newEmployment, "user_id", vm.id);
          vm.newEmployment.members = vm.newEmployment.people.map((item) => {
            return item.id;
          });
          Object.keys(vm.newEmployment.skills).forEach(function (key) {
            vm.newEmployment[key] = vm.newEmployment.skills[key];
          });
          if (!vm.newEmployment.id) {
            // Add new employment
            vm.$store
              .dispatch(
                "COMPANY_CONSULTANT_ADD_NEW_EMPLOYMENT",
                vm.newEmployment
              )
              .then((responce) => {
                vm.save_employment_loading = false;
                vm.getConsultantData(vm.id);
              })
              .catch((error) => {
                vm.save_employment_loading = false;
                console.log({
                  error,
                });
              });
          } else {
            // Update employment
            vm.$store
              .dispatch(
                "COMPANY_CONSULTANT_UPDATE_EMPLOYMENT",
                vm.newEmployment
              )
              .then((responce) => {
                vm.save_employment_loading = false;
                vm.getConsultantData(vm.id);
              })
              .catch((error) => {
                vm.save_employment_loading = false;
                console.log({
                  error,
                });
              });
          }
        }
      });
    },
    getConsultantData(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_CONSULTANT_ALL_DATA", {
          id: id,
        })
        .then((responce) => {
          vm.profile_data = responce.data;
          vm.showItemsList();
          let employments_data = vm.processSkills(vm.profile_data.employment);
          eventBus.$set(vm.profile_data, "employments", employments_data);
        })
        .catch((error) => {
          console.log({
            error,
          });
        });
    },
    processSkills(obj) {
      return obj.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: {
                    name: item.lang.name,
                  },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills_data", item.skills);
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    loadCities(e) {
      this.$store.dispatch("GET_CITIES", {
        country: e.target.value,
      });
    },
    addUpdateForm() {
      let vm = this;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
      vm.newEmployment = {
        skills: {},
        skills_data: [],
        name: "",
        company: "",
        from: "",
        to: "",
        country: 0,
        city: 0,
        address: "",
        location: {
          country: 0,
          city: 0,
          address: "",
        },
        description: "",
        hourly_rate: "",
        member: "",
        langs: [],
        members: [],
        people: [],
        invites: [],
        langNames: [],
        show: false,
        roles: [],
        role: "",
      };
    },
    closeAddUpdateForm() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
    },
    showItemsList() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
    },
    showVerifyForm(id) {
      let vm = this;
      vm.show_verify = true;
      vm.is_items_list_open = false;
      eventBus.$set(vm.request, "employment_id", id);
    },
    closeVerifyForm() {
      let vm = this;
      vm.show_verify = false;
      vm.is_items_list_open = true;
    },
  },
  watch: {
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.employment-wrapper {
  width: 100%;
  .employment-widget {
    width: 100%;
    ul.employment-items {
      background: #ffffff;
      padding: 0px 20px;
      padding-bottom: 20px;
      list-style: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      margin: 0px;
      .employment-starter {
        margin-bottom: 6px;
        position: sticky;
        top: 0px;
        z-index: 999;
        background: #fff;
        .employment-item-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0px;

          label {
            color: #000000;
            font-family: "AvenirBook";
            font-size: 16px;
            @media (min-width: 300px) and (max-width: 630px) {
              font-size: 16px !important;
              font-weight: 800;
            }
          }

          .btn-add {
            color: #1ba5a4;
            border: none;
            padding: 10px 10px;
            font-size: 14px;
            outline: none;
            cursor: pointer;
            font-family: "AvenirBook";
            font-style: italic;
            background: transparent;
          }
        }

        p {
          color: #131313;
          font-family: "AvenirBook";
        }
      }

      .employment-item {
        background: #f5f5f5 0% 0% no-repeat padding-box;
        border-radius: 5px;
        margin-bottom: 10px;

        .employment-item-header {
          display: grid;
          padding-top: 9px;
          padding-left: 9px;
          padding-right: 9px;
          grid-template-columns: 60px calc(97% - 60px);
          grid-column-gap: 20px;
          position: relative;
          &.no_expand {
            padding-bottom: 9px;
            &:hover {
              cursor: pointer;
              background: #e9e9e9;
              border-radius: 4px;
            }
          }
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
            grid-column-gap: 10px;
            padding: 10px 17px;
          }
          .employment-item-brand {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            background: rgb(228, 228, 228);
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              width: 60px;
              height: 60px;
              display: none;
            }
            img {
              width: 40px;
              height: 40px;
              object-fit: contain;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 33px;
                height: 33px;
              }
            }
          }

          .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 99%;
            .title-row {
              font-family: "AvenirBook";
              padding-right: 9px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 99%;
              label {
                display: block;
                font-size: 14px;
                font-family: "AvenirBook";
                margin-bottom: 5px;
                font-weight: 800;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }

              span {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                margin-bottom: 6px;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }
            }
            .options {
              display: flex;
              align-items: flex-end;
              flex-direction: column;
              .btns {
                display: flex;
                align-items: center;
              }
              .verified-status {
                color: #0590ab;
                margin: 10px 0px;
              }
              .btn-verify {
                height: 40px;
                width: 100px;
                outline: none;
                color: #fff;
                background-color: #1890a9;
                border-radius: 5px;
              }
              .date {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                display: flex;
                justify-content: flex-end;
                width: 188px;
                align-items: center;
                .separator {
                  margin: 0px 5px;
                }
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 11px;
                  width: 145px;
                }
              }

              .status {
                color: #000;
                font-family: "AvenirBook";
                font-size: 13px;
              }

              .toogle-panel-btn {
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: relative;
                bottom: 5px;
                left: 4px;
                margin-top: 29px;
                img {
                  width: 13px;
                }
              }
            }
          }

          .toogle-panel-btn {
            padding: 1px 40px;
            font-size: 30px;
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            color: #ccc;
          }
        }

        .employment-item-body {
          padding-bottom: 9px;
          padding-left: 9px;
          padding-right: 9px;

          .employment-info {
            h5 {
              text-align: left;
              color: #6e6e6e;
              font-size: 14px;
              margin-bottom: 5px;
            }

            p {
              text-align: left;
              color: #000;
              font-size: 13px;
              font-weight: 800;
              margin-top: 0px;
            }

            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;

              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;

                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }

                .name {
                  color: #fff;
                }
              }
            }

            .skills-widget {
              .skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-column-gap: 10px;
                margin-bottom: 10px;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }

                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;

                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;

                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }

                  .skill_box_body {
                    padding: 0px 15px;

                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 80px;
                      justify-content: center;

                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }

                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }

                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;

                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }

              .next_skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 10px;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }

                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;

                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;

                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }

                  .skill_box_body {
                    padding: 0px 15px;

                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 80px;
                      justify-content: center;

                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }

                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }

                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;

                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
            }
          }

          .employment-item-body-option {
            display: flex;
            justify-content: flex-end;

            .toogle-panel-btn {
              padding: 1px 9px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              height: 36px;
              width: 19px;
              padding: 0;
              height: 22px;
              font-size: 20px;
              position: relative;
              top: -3px;
              right: -5px;
              img {
                width: 13px;
              }
            }
          }
        }
      }
    }

    .empty-widget {
      background: #fff;
      padding: 20px;

      .empty-widget-body {
        height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        p {
          text-align: center;
          width: 269px;
        }

        .add-btn {
          width: 180px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
      }
    }
  }

  .add-update-form {
    background: #fff;
    padding: 20px;
    border-radius: 5px;

    .form {
      background: #f7f7f7;
      padding: 20px;
      border-radius: 5px;

      h2 {
        font-family: Avenir;
        font-size: 13px;
        font-weight: 900;
        font-stretch: normal;
        font-style: normal;
        line-height: 3.77;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      span {
        font-size: 14px;
        margin-left: 10px;
        margin-bottom: 10px;
        color: #646262;
      }

      .__row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        h2 {
          color: #000000;
          font-weight: normal;
          line-height: 0px;
          font-size: 22px;
        }

        button {
          background: transparent;
          outline: none;
          color: #680404;
          width: 94px;
          border-radius: 5px;
          border: 0.5px solid #7e0505;
          height: 27px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            margin-left: 20px;
          }
        }
      }

      .skills-input-widget {
        margin-bottom: 20px;
      }

      .form-group {
        display: flex;
        justify-content: space-between;

        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: column;
        }

        .__box {
          max-width: 50%;
          width: 50%;
          display: flex;
          flex-direction: column;

          @media (min-width: 300px) and (max-width: 630px) {
            max-width: 100%;
            width: 100%;
          }

          span {
            font-family: Avenir;
            font-size: 14px;
            font-weight: 300;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            text-align: left;
            color: #646262;

            b {
              font-weight: 900;
              color: #0884af;
            }
          }

          .grouped,
          input[type="text"],
          textarea,
          select {
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
            background: #fff;
            font-size: 14px;
            resize: none;
            display: flex;
            margin-bottom: 20px;
            justify-content: space-between;
            width: 100%;
            padding: 10px;
            outline: none;
            border-radius: 5px;
            border: none;
            color: #707070;

            @media (min-width: 300px) and (max-width: 630px) {
              margin-bottom: 4px;
            }

            .__date-field,
            .__date-field2 {
              background-color: #f4f4f4;
              background-image: url($assets + "/icons/calendar__icon.svg");
              background-repeat: no-repeat;
              background-position: right;
              width: 49%;
              border-radius: 5px;
              padding: 5px;
              background-position-x: 96%;
            }
          }

          .grouped {
            padding: 5px 5px;
          }

          .disabling {
            .__date-field2 {
              opacity: 0.3;
              background-color: #f4f4f4;
              background-image: none;
              background-repeat: no-repeat;
              background-position: right;
              width: 49%;
              border-radius: 5px;
              padding: 5px;
            }
          }

          textarea {
            height: 100px !important;
          }
        }
      }
      .form-label-title {
        margin-top: 20px;
      }
      .help-widget-absolute {
        position: absolute;
      }

      .__box {
        max-width: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;

        &.member-widget {
          .invite-widget {
            @media (min-width: 300px) and (max-width: 630px) {
              flex-direction: column;
              align-items: flex-start !important;
            }
            .__textview {
              @media (min-width: 300px) and (max-width: 630px) {
                width: 100% !important;
              }
            }
          }
        }

        span {
          font-family: Avenir;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          text-align: left;
          color: #646262;

          b {
            font-weight: 900;
            color: #0884af;
          }
        }

        .grouped,
        input[type="text"],
        textarea,
        select {
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
          background: #fff;
          font-size: 13px;
          resize: none;
          display: flex;
          margin-bottom: 0px;
          justify-content: space-between;
          width: 100%;
          padding: 10px;
          outline: none;
          border-radius: 5px;
          border: none;
          color: #707070;
          height: 45px;

          .__date-field {
            background: #f4f4f4;
            width: 49%;
            border-radius: 5px;
            padding: 5px;
          }
        }

        textarea {
          height: 100px !important;
        }
      }

      .input__dropdown {
        margin-bottom: 20px;
        .dropdown__wrapper {
          position: relative;
          .invite-widget {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .__textview {
              width: 360px;
            }

            .btn-invite-via-email {
              background: #1ba5a4;
              color: #fff;
              font-size: 14px;
              font-weight: normal;
              cursor: pointer;
              border-radius: 5px;
              height: 40px;
              width: 160px;
              padding: 3px 10px;
            }
          }

          .dropdown__body {
            background: #fff !important;
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
            border-radius: 4px;
            position: absolute;
            width: 361px;
            top: 47px;
            z-index: 10;
            min-height: 158px;

            .dropdown__item {
              display: flex;
              cursor: pointer;
              padding: 0px 15px 5px 15px;
              margin-top: 10px;
              border-bottom: 1px solid #e6e6e6;
              flex-direction: row;

              img {
                width: 19px;
                border-radius: 100px;
                height: 19px;
                margin-right: 8px;
              }

              .text {
                display: flex;
                color: #808080;
                margin-top: -3px;
                font-size: 8pt;
                flex-direction: column;

                .small {
                  font-size: 6pt;
                  font-weight: normal;
                  margin-top: -2px;
                }
              }
            }
          }
        }
      }

      .__people {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        margin-bottom: 26px;
        position: relative;
        top: -11px;

        .person__item {
          position: relative;
          margin-right: 13px;

          .person_avatar {
            display: flex;
            background: #1ba5a4;
            border-radius: 21px;
            align-items: center;
            padding: 3px 4px;

            img {
              width: 30px;
              height: 30px;
              object-fit: cover;
              border-radius: 50%;
            }

            .person_name {
              color: #fff;
              margin: 0px;
              margin-left: 5px;
              margin-right: 6px;
            }
          }

          .__close {
            background: maroon;
            position: absolute;
            right: -6px;
            cursor: pointer !important;
            top: -6px;
            width: 20px;
            height: 20px;
            border-radius: 100px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 8px;
              cursor: pointer !important;
              height: 8px;
            }
          }
        }
      }

      .__btns {
        display: flex;
        width: 30%;
        margin-top: 30px;
        justify-content: space-between;

        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }

        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;

          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }

  .verify-form {
    background: #fff;
    border-radius: 5px;
    padding: 20px;

    @media (min-width: 300px) and (max-width: 630px) {
      padding: 0px;
    }

    .employment-form {
      background: #f5f5f5;
      padding: 20px;

      @media (min-width: 300px) and (max-width: 630px) {
        padding-top: 18px;
        padding-left: 11px;
        padding-right: 11px;
        padding-bottom: 39px;
      }
    }

    .__label {
      margin-bottom: 8px;
      display: block;
    }

    .__box {
      margin-bottom: 20px;
      .input-group {
        display: grid;

        input {
          width: 100%;
          height: 40px;
          background: #fff;
          padding: 0px 13px;
          border-radius: 5px;
          outline: none;
        }
      }
    }

    .__btns {
      display: flex;
      width: 100%;
      margin-top: 30px;
      align-items: center;
      .cancel {
        color: #1ba5a4;
        cursor: pointer;
        font-weight: normal;
        height: 30px;
        padding: 3px 20px;
        font-size: 14px;
      }

      .save {
        background: #1ba5a4;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        cursor: pointer;
        border-radius: 5px;
        height: 40px;
        padding: 3px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:disabled {
          background: #8d8d8d;
          opacity: 0.3;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.card__body {
  padding: 20px;
  z-index: 9999;
  width: 100%;

  .__layout {
    .div {
      label {
        opacity: 0.51;
        font-family: Avenir;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        color: #161615;
      }

      input {
        height: 30px;
        width: 100%;
        background: #fff;
        font-size: 14px;
        font-weight: 300;
        padding: 0 10px;
        margin: 10px 0;
        outline: none !important;
        border: none !important;
        border-radius: 5px;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;

        &:focus {
          border: none !important;
          outline: none !important;
        }

        &::placeholder {
          opacity: 0.5;
          font-style: italic;
        }
      }

      .msg {
        background: #fff;
        margin-top: 10px;
        border-radius: 5px;
        opacity: 0.68;
        padding: 10px;
        font-size: 13px;
        color: #676767;
      }
    }
  }

  .__cont {
    display: flex;
    flex-direction: column;

    .icons {
      display: flex;
      width: 100%;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 0.7px solid #a0a0a0;
      margin-top: 10px;

      div {
        margin-right: 10px;

        label {
          font-size: 12px;
          margin-right: 10px;
        }

        input {
          margin-top: 5px;
        }
      }
    }

    .body {
      padding: 20px;
      border-radius: 5px;
      background: #f4f4f4;
      border: 1px solid #707070;

      .template {
        width: 100%;
        background: #fff;
        box-shadow: 0 6px 5px rgba(0, 0, 0, 0.16);
        margin-right: 10px;

        button {
          height: 10px;
          font-size: 4px;
          outline: none;
          color: #fff;
          border: none;
          background: #0e9695;
        }

        .header {
          display: flex;
          width: 100%;

          .first {
            display: flex;
            padding-left: 10px;
            padding-right: 10px;
            flex-direction: column;

            img {
              width: 30px;
              height: 30px;
              border-radius: 100%;
            }

            h2 {
              font-size: 6px;
              margin-top: 10px;
            }
          }

          .second {
            background: #0075a0;
            display: flex;
            flex-grow: 1;
            justify-content: center;
            align-items: center;

            .titles {
              display: flex;
              color: #fff;
              width: 100%;
              justify-content: space-between;
              padding-left: 10px;
              padding-right: 10px;

              h2 {
                font-size: 4px;
              }

              button {
                height: 10px;
                font-size: 4px;
                outline: none;
                border: none;
                background: #0e9695;
              }
            }
          }
        }

        .contents {
          display: flex;
          width: 100%;

          span,
          p,
          button {
            font-size: 4px !important;
          }

          .left {
            width: 100px;
          }

          .right {
            flex-grow: 1;
          }
        }
      }
    }

    .actiond {
      margin-top: 10px;
      display: flex;

      button {
        background: #1890a9;
        color: #fff;
        border-radius: 5px;
        padding: 5px 10px;
        justify-content: space-between;
        align-items: center;
      }

      .cancel {
        background: transparent;
        color: #0590ab;
      }
    }
  }

  .__input {
    margin: 20px 0;
    width: 100%;

    span {
      color: #979797;
      font-size: 14px;
      font-weight: normal;
    }

    input {
      width: 100%;
      color: gray;
      font-size: 14px;
      height: 30px;
      outline: none;
      background: #e9ebed;
      border-radius: 3px;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.16);
      padding: 2px 10px;
    }
  }

  .btns {
    display: flex;
    width: 50%;
    float: right;
    justify-content: space-between;

    .cancel {
      color: #1ba5a4;
      cursor: pointer;
      font-weight: normal;
      height: 22px;
      padding: 1px 20px;
      font-size: 14px;
    }

    .save {
      background: #1ba5a4;
      color: #fff;
      font-size: 14px;
      font-weight: normal;
      cursor: pointer;
      border-radius: 5px;
      height: 22px;
      padding: 1px 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:disabled {
        background: #8d8d8d;
        opacity: 0.3;
      }
    }
  }

  .btns-2 {
    display: flex;
    float: right;
    margin-top: 20px;

    .save {
      width: 100px;
      height: 40px;
      font-size: 14px;
      outline: none;
      opacity: 0.97;
      border-radius: 0.6vh;
      font-family: Avenir;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(
        to right,
        #1d9694 0%,
        #199295 36%,
        #108798 68%,
        #01759e 98%,
        #00749f 100%
      );
    }

    .cancel {
      width: 100px;
      height: 40px;
      font-size: 14px;
      outline: none;
      opacity: 0.51;
      font-family: Avenir;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #161615;
    }
  }

  .__body {
    background: #f0eaea;
    padding: 20px;

    .__rowed {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      justify-content: space-between;

      span {
        color: #646262;
        font-size: 12px;
      }

      input,
      select {
        background: #ffffff;
        border-radius: 5px;
        padding: 5px 10px;
        outline: none;
        width: 80%;
        font-size: 12px;
        color: #c4c4c4;
      }

      select {
        width: 30%;
      }

      img {
        cursor: pointer;
      }

      .img {
        max-width: 15px;
        max-height: 15px;
      }
    }
  }

  .__rowed {
    position: relative;
  }
}
</style>
